import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { staticClass: "icon", attrs: { "t": "1705479915160", "viewBox": "0 0 1024 1024", "version": "1.1", "xmlns": "http://www.w3.org/2000/svg", "p-id": "3251", "width": "20", "height": "20" } }, [_c("path", { attrs: { "d": "M511.9488 460.8a204.8 204.8 0 1 0 0-409.6 204.8 204.8 0 0 0 0 409.6zM512 691.2L405.3504 563.2H396.8a268.8 268.8 0 0 0-268.8 268.8v48.0256c0 37.0688 30.1056 67.1744 67.2256 67.1744h633.5488c37.12 0 67.2256-30.1056 67.2256-67.2256v-47.9744c0-148.48-120.32-268.8-268.8-268.8h-8.5504L512 691.2z", "p-id": "3252", "fill": "currentColor" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const UserIcon = __component__.exports;
export {
  UserIcon as default
};
